import { render, staticRenderFns } from "./RegraFiscalClienteForm.vue?vue&type=template&id=21178856"
import script from "./RegraFiscalClienteForm.vue?vue&type=script&lang=js"
export * from "./RegraFiscalClienteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports